import styled from 'styled-components'
import { SIZES } from '../../../styles/theme'

export const AbstractRatingDiv = styled.div`
  ${SIZES.mobile} {
    margin-bottom: 20px;

    svg {
      height: 25px;
    }
  }
  .ratedText {
    margin: 0;
    font-weight: 200;
  }
`
